// @ts-nocheck
/* eslint-disable */
export const arrowRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5.453 4.053v7.894c0 .64.774.96 1.227.506L10.133 9a1.42 1.42 0 0 0 0-2.007L8.82 5.68 6.68 3.54a.721.721 0 0 0-1.227.513"/></svg>`,
    name: 'arrow-right' as const
};